import type { AxShareConfigModel } from "@/generated/models";
import { toCdnUrl } from "ls/composables/useCdnUrl";
import { removeEmojis } from "@/common/lib/string";

export function toImageCdnUrl(shortcut: string, imageHash: string, config: AxShareConfigModel, options: { type: "icon" | "banner" }) {
  const url = new URL(toCdnUrl(`/icons/${shortcut.toLowerCase()}/${imageHash}`, config));

  if (options.type) {
    url.searchParams.set("type", options.type);
  }

  return url.toString();
}

export function getIconFallbackLetter(name: string) {
  const noEmojis = removeEmojis(name);
  return noEmojis.trim().charAt(0).toUpperCase() || "?";
}
